export function base64Encode(input: string): string {
	const utfArray = new TextEncoder().encode(input);
	const binaryString = Array.from(utfArray, (byte) => String.fromCodePoint(byte)).join(
		''
	);
	return btoa(binaryString);
}
